// extracted by mini-css-extract-plugin
module.exports = {"noteContainer":"ClientTableRow__noteContainer--1JaLm","note":"ClientTableRow__note--1RAGq"};